export const questions = [
    {question: "Do you have advice for making my application stronger?"},
    {question: "Where can I find the module outline?"},
    {question: "When can I apply for accommodation?"},
    // {question: "What are your tips for my personal statement?"},
    {question: "How should I write my personal statement?"},
    {question: "What grades do I need to get in?"},
    // {question: "What did you put in your personal statement?"},
    {question: "What are the interviews like?"},
    {question: "What is the application process like?"},
    {question: "Is there part-time work at university?"},
    {question: "What are the dates for the open days?"},
    {question: "How do I get in touch with the admissions team?"},
    {question: "How long is the interview?"},
    {question: "Is the accommodation near to the university?"},
    {question: "What sports are available?"},
    // {question: "What do you think about this uni?"},
    {question: "How long does the visa application take?"},
    {question: "Is the course popular at this uni?"},
    {question: "What does the course cover?"},
    {question: "How many modules will I study?"},
    {question: "Is travel expensive?"},
    {question: "What is the nightlife like?"},
    {question: "Is the teaching highly ranked here?"},
    {question: "What is the campus like?"},
    {question: "When is the application deadline?"},
    {question: "What are the entry requirements?"},
    // {question: "How do I contact my personal tutor?"},
    {question: "Is my attendance monitored?"},
    {question: "Is there a lot of essays?"},
    {question: "When will I receive a book list?"},
    {question: "Does this university offer internships?"},
    {question: "How far is the train station from the campus?"},
    {question: "What is the local area like?"},
    // {question: "Are the societies good?"},
    {question: "Why did you choose to join that university?"},
    {question: "How many people are enrolled on the course?"},
    {question: "How much are the fees?"},
    {question: "Can I visit the campus?"},
    {question: "Is there food near the campus?"},
    {question: "What kind of questions do they ask at the interview?"},
    {question: "Does the university offer careers support?"},
    {question: "What are the career prospects for this course?"},
    {question: "Can I choose which modules I study?"},
    {question: "How is the course taught?"},
    {question: "How many hours do you study each week?"},
    {question: "Are there ensuite rooms in the dorms?"},
    {question: "Is university expensive?"},
    {question: "Can I visit the university at any time?"},
    {question: "How can I apply for a visa?"},
    {question: "Is there support with job applications?"},
    {question: "Does first year count towards the final grade?"},
    {question: "Can I choose where to do my industry placement?"},
    {question: "Do you offer bursaries?"},
    {question: "What are the average monthly living costs?"},
    {question: "Is the university near to shops?"},
    {question: "How can I prepare for university?"},
    {question: "Can you give me some tips for the interview?"},
    {question: "Can I balance part-time work and my studies?"},
    {question: "Is there a lot of coursework?"},
    {question: "Am I able to switch modules?"},
    {question: "Are there exams on this course?"},
    // {question: "How hard are the exams?"},
    {question: "Where can I get books?"},
    {question: "Where is the university?"},
    {question: "Does this university get good feedback?"},
    {question: "How important is my personal statement?"},
    {question: "Do I need visa to study there?"}, // Missing "a" before visa, should be here instead of there
    {question: "When will I receive my offer?"},
    {question: "What can you do after university with this degree?"},
    {question: "Are students safe at the university?"},
    {question: "When can I visit the university?"},
    {question: "Is there a gym?"},
    {question: "Are there interviews for this course?"},
    {question: "How is the course structured?"},
    {question: "What kind of modules are available?"},
    {question: "Can I apply for accommodation if I live nearby?"},
    {question: "Are there societies or clubs at university?"},
    {question: "What is the overall satisfaction for this uni?"},
    // {question: "What is the gym like?"},
    {question: "What happens if I miss a class?"},
    {question: "Does the workload change throughout the year?"},
    {question: "What kind of internships are available?"},
    {question: "Are the rooms catered?"},
    {question: "What kind of support is available?"},
    {question: "Is the library big or small?"},
    {question: "What is the parking like at the university?"},
    {question: "Where does this university rank?"},
    {question: "How do I get released into Clearing?"},
    {question: "What are the contact hours?"},
    {question: "Can I apply for a bursary?"},
    {question: "Can you tell me about study abroad?"},
    {question: "When do I pay back student loans?"},
    {question: "Does the university help students with internship applications?"},
    {question: "How much are the tuition fees?"},
    {question: "What types of accommodation are available?"},
    {question: "Are there any clubs?"},
    // {question: "Which societies would you recommend?"},
    {question: "What is the social life like?"},
    {question: "How long is the library open?"},
    {question: "Is the university in a good area?"},
    {question: "What are the lecturers like?"},
    // {question: "Is the course hard?"},
    {question: "Does this university offer exchanges?"},
    // {question: "How do you find living in a city?"},
    {question: "Where is the campus?"},
    {question: "Can you tell me about the living costs?"},
    {question: "Is there a counselling service?"},
    {question: "Does the library tend to be busy?"},
    {question: "What is the nearest train station?"},
    {question: "What is the criteria for a bursary?"},
    {question: "What are the tuition fees for international students?"},
    {question: "How do I sign up for a society?"},
    {question: "Do students like this university?"},
    {question: "Which teaching styles are used?"},
    {question: "Are the exams compulsory?"},
    {question: "When are the exams?"},
    {question: "Do students ever fail their exams?"},
    {question: "What would studying abroad involve?"},
    {question: "Is the area safe?"},
    {question: "Is it a safe place to study?"},
    {question: "Where is the accommodation?"},
    {question: "What bursaries am I eligible for?"},
    {question: "How much money will I get with a student loan?"},
    {question: "How is the student life there?"},
];
